import React, { useState, useEffect, useRef } from "react";
import {
  commentsNew,
  PAYWALL_FOURTH,
  PRIVACY_LINK,
  TERMS_LINK,
  paywallFourthlData,
  fourth_paywall_timeline_items,
  secondItems,
} from "../../../constants/data";
import { useSelector } from "react-redux";
import {
  CardInputWrapper,
  PaymentBlock,
  SubscriptionBlock,
  TimeBlock,
} from "../styled";
import { Container, Heading, ImageItem, Text } from "../../../styled";
import {
  blackColor,
  blueColor,
  blueDarkColor,
  disabledColor,
  greyAddColor,
  greyDarkColor,
  greyLightColor,
  greyTextColor,
  lightSecondColor,
  orangeColor,
  purpleColor,
  purpleSecondColor,
  slideBgColor,
  whiteColor,
} from "../../../constants/colors";
import okIcon from "./../../../resources/images/subscription/ok_orange_icon.svg";
import stamp from "./../../../resources/images/subscription/stamp.svg";
import stampNew from "./../../../resources/images/paywall/stamp_2.png";
import methodIcon from "./../../../resources/images/subscription/payment_method.png";
import keyIcon from "./../../../resources/images/subscription/key.svg";
import stripeIcon from "./../../../resources/images/subscription/stripe.png";
import tableIcon from "./../../../resources/images/subscription/table.png";
import healthIcon from "./../../../resources/images/paywall/health_icon.png";
import starsIcon from "./../../../resources/images/paywall/stars.svg";
import drNewIcon from "./../../../resources/images/paywall/dr_new_1.png";
import drNew2Icon from "./../../../resources/images/paywall/dr_new_2.png";
import yaleIcon from "./../../../resources/images/paywall/yale.png";
import closeIcon from "./../../../resources/images/paywall/close.svg";
import avatarsIcon from "./../../../resources/images/paywall/avatars.png";
import backIcon from "./../../../resources/images/paywall/back.svg";
import appleIcon from "./../../../resources/images/paywall/logo_apple.png";
import ratingIcon from "./../../../resources/images/paywall/rating.svg";
import timeLineImg from "./../../../resources/images/paywall/timeline.png";
import paypalLetters from "./../../../resources/images/paymentForm/PP.svg";
import paypalBig from "./../../../resources/images/paymentForm/pm_paypal.png";
import warningIcon from "./../../../resources/images/paymentForm/warning.svg";
import PopupTemplate from "../../design_components/Popup/PopupTemplate";
import PaymentForm from "./../PaymentForm/PaymentForm";
import logoImg from "./../../../resources/images/paywall/logo_new_blue.svg";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import { Pagination, Autoplay } from "swiper";

// Import Swiper styles
import "swiper/modules/pagination/pagination.min.css";
import "swiper/swiper-bundle.css";
// import "swiper/core/";
import {
  comments,
  scrollHeight,
  timeRemaining,
  PAYWALL_FIRST,
  PAYWALL_SECOND,
  PAYWALL_THIRD,
} from "../../../constants/data";
import Button from "../../design_components/Button/Button";
import {
  createEventObjectFunction,
  getCurrentYear,
} from "../../../utils/helper";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import {
  paymentInfoAddEventAmplitude,
  paymentTypeEventAmplitude,
  paywallOpenEventAmplitude,
} from "../../../amplitude/events";
import {
  paymentInfoAddEvent,
  paymentTypeEvent,
  paywallOpenEvent,
} from "../../../firebaseAnalytics/events";
import { analytics } from "../../../firebaseAnalytics";
import { PaywallPopupBlock, PaywallTopBlock, PaypalPopupBlock } from "./styled";
import blueBg from "../../../resources/images/utils/blue.png";
import purpleBg from "../../../resources/images/utils/purple.png";
import bird from "../../../resources/images/icons/bird_green.svg";
import { PrepaywallBlock } from "../../Prepaywall/styled";

const Paywall = (props) => {
  const { userSum, pixelObject, landingId } = props;
  const PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY;

  const remoteConfig = useSelector((state) => state.questions.remoteConfig);
  const userEmail = useSelector((state) => state.questions.userEmail);

  // определяет номер пейвола для вызова определенной функции рендер
  const [currentPaywall, setCurrentPaywall] = useState(remoteConfig.paywallId);
  // определяет в целом концепцию пейвола (1 и 4 в одном стиле)
  const [paywallState, setPaywallState] = useState(remoteConfig.paywallId);
  // автоматическое открытие модального окна на первом и третьем пейволле
  const [isPaywallPopupOpen, setPaywallPopupOpen] = useState(
    remoteConfig.paywallId === PAYWALL_FIRST ||
      remoteConfig.paywallId === PAYWALL_THIRD
  );

  const [activeBullet, setActiveBullet] = useState(0);

  const [counter, setCounter] = useState(timeRemaining);
  // таймер пока не используется, но в будущем может понадобиться
  const [isTimeVisible, setTimeVisible] = useState(false);

  const [isPaymentVisible, setPaymentVisible] = useState(false);
  const [isWhyPopupVisible, setWhyPopupVisible] = useState(false);
  const [stripePromise, setStripePromise] = useState(() =>
    loadStripe(PUBLIC_KEY)
  );

  // payment method state
  const [isPaypalMethod, setPaypalMethod] = useState(false);
  const [isPaypalAvailable, setPaypalAvailable] = useState(true);

  const [isPaypalPopupVisible, setPaypalPopupVisible] = useState(false);
  const [paypalPopupState, setPaypalState] = useState(0);

  const [isInputFill, setInputFill] = useState(false);
  const [isInputError, setInputError] = useState(false);

  const [paypalInputClicked, setPaypalInputClicked] = useState(false);

  const [isFormVisible, setIsFormVisible] = useState(false);
  const [isFormVisibleSecond, setFormVisibleSecond] = useState(false);

  useEffect(() => {
    window.scrollTo(0, document.body);
    window.addEventListener("scroll", checkFormVisible);
    return () => window.removeEventListener("scroll", checkFormVisible);
  }, []);

  useEffect(() => {
    if (isFormVisible === true && isFormVisibleSecond === false) {
      handleGetMyPlanClick(true);
    } else {
      return false;
    }
  }, [isFormVisible]);

  const checkFormVisible = () => {
    let paymentYcoord =
      formBlock &&
      formBlock.current &&
      formBlock.current.getBoundingClientRect().y;
    if (paymentYcoord < 350) {
      setIsFormVisible(true);
    }
  };

  const formBlock = useRef(null);

  const padTime = (time) => {
    return String(time).length === 1 ? `0${time}` : `${time}`;
  };

  const format = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${padTime(seconds)}`;
  };

  const calculateScroll = (e) => {
    if (scrollY > scrollHeight) {
      setTimeVisible(true);
    } else {
      setTimeVisible(false);
    }
  };

  useEffect(() => {
    const eventObj = createEventObjectFunction(null, null, landingId);
    eventObj.type = "short";
    const options = {
      root: document.querySelector(".observer-element"),
      rootMargin: "0px",
      threshold: 1.0,
    };
    // Событие №8 paywall open
    paywallOpenEvent(analytics, eventObj);
    paywallOpenEventAmplitude(eventObj);

    window.addEventListener("scroll", (e) => calculateScroll(e));
    return window.removeEventListener("scroll", (e) => calculateScroll(e));
  }, []);

  useEffect(() => {
    let timer;
    if (counter > 0) {
      timer = setTimeout(() => setCounter((c) => c - 1), 1000);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [counter]);

  useEffect(() => {
    if (remoteConfig.paywallId === PAYWALL_FOURTH) {
      setPaywallState(1);
    } else {
      setPaywallState(remoteConfig.paywallId);
    }
    setCurrentPaywall(remoteConfig.paywallId);
  }, [remoteConfig]);

  const commentsRender = () => {
    return comments.map((comment, index) => {
      return (
        <SubscriptionBlock.Comments.Item key={`comment-${index}`}>
          <SubscriptionBlock.Comments.Top>
            <SubscriptionBlock.Comments.Top.Left>
              <img src={comment.avatar} alt="avatar" />
            </SubscriptionBlock.Comments.Top.Left>
            <SubscriptionBlock.Comments.Top.Right>
              <SubscriptionBlock.Comments.Top.Right.Top>
                <Text.Fourth style={{ opacity: 0.7 }}>
                  <b>{`${comment.name}`}</b> recommends <b>Journey</b>
                </Text.Fourth>
              </SubscriptionBlock.Comments.Top.Right.Top>
              <SubscriptionBlock.Comments.Top.Right.Bottom>
                <img src={comment.img} alt="" />
                <Text.Fourth style={{ opacity: 0.7 }}>
                  {comment.count}
                </Text.Fourth>
              </SubscriptionBlock.Comments.Top.Right.Bottom>
            </SubscriptionBlock.Comments.Top.Right>
          </SubscriptionBlock.Comments.Top>
          <SubscriptionBlock.Comments.Bottom>
            <Text.Second style={{ textAlign: "left" }}>
              {comment.text}
            </Text.Second>
          </SubscriptionBlock.Comments.Bottom>
        </SubscriptionBlock.Comments.Item>
      );
    });
  };

  const commentsNewRender = () => {
    return commentsNew.map((comment, index) => {
      return (
        <div className="paywall-comment-new">
          <div className="paywall-comment-new-text">
            <Text.Fourth
              style={{ textAlign: "left" }}
              dangerouslySetInnerHTML={comment.text}
            />
          </div>
          <div className="paywall-comment-new-bottom">
            <div className="paywall-comment-new-avatar">
              <div className="paywall-comment-new-image">
                <img src={comment.avatar} alt="avatar" />
              </div>
              <div className="paywall-comment-new-name">
                <Text.Fifth
                  style={{
                    fontWeight: 400,
                    color: purpleSecondColor,
                    textAlign: "left",
                  }}
                >
                  {`${comment.name}, ${comment.age}`}
                </Text.Fifth>
                <Text.Fifth
                  style={{
                    fontWeight: 400,
                    color: purpleSecondColor,
                    textAlign: "left",
                  }}
                >
                  {comment.place}
                </Text.Fifth>
              </div>
            </div>
            <div className="paywall-comment-new-stars">
              <img src={comment.img} alt="stars" />
            </div>
          </div>
        </div>
      );
    });
  };

  const paymentBlockRender = () => {
    return (
      <PaymentBlock>
        <PaymentBlock.Back onClick={() => setPaymentVisible(false)}>
          <img src={backIcon} alt="" />
        </PaymentBlock.Back>
        <PaymentBlock.Top>
          <PaymentBlock.Top.Title style={{ marginBottom: 23 }}>
            <Heading.Fifth style={{ color: blackColor }}>
              Payment method
            </Heading.Fifth>
            <Text.Fifth
              style={{ color: orangeColor, fontWeight: 700 }}
              onClick={() => setWhyPopupVisible(true)}
            >
              Why now?
            </Text.Fifth>
          </PaymentBlock.Top.Title>
          <PaymentBlock.Top.Method>
            <img style={{ height: 31 }} src={methodIcon} alt="Visa" />
          </PaymentBlock.Top.Method>
          <PaymentBlock.Top.Title>
            <Heading.Fifth style={{ color: blackColor }}>
              Payment information
            </Heading.Fifth>
            <Text.Fifth
              style={{
                color: "#6C6C6C",
                fontWeight: 700,
                display: "flex",
                alignItems: "center",
              }}
            >
              <img src={keyIcon} alt="" style={{ marginRight: 6 }} />
              <span>Secure Server</span>
            </Text.Fifth>
          </PaymentBlock.Top.Title>
        </PaymentBlock.Top>
        <PaymentBlock.Form>
          <PaymentBlock.Form.Top>
            <span>Powered by</span>
            <img style={{ height: 34 }} src={stripeIcon} alt="" />
          </PaymentBlock.Form.Top>
          <PaymentBlock.Form.Inputs>
            {paymentFormRender()}
          </PaymentBlock.Form.Inputs>
          <SubscriptionBlock.List.Items>
            <SubscriptionBlock.List.Item>
              <SubscriptionBlock.List.Item.Img>
                <img src={okIcon} alt="ok" />
              </SubscriptionBlock.List.Item.Img>
              <SubscriptionBlock.List.Item.Text>
                <Text.Third>{`7-day trial for free`}</Text.Third>
              </SubscriptionBlock.List.Item.Text>
            </SubscriptionBlock.List.Item>
            <SubscriptionBlock.List.Item>
              <SubscriptionBlock.List.Item.Img>
                <img src={okIcon} alt="ok" />
              </SubscriptionBlock.List.Item.Img>
              <SubscriptionBlock.List.Item.Text>
                <Text.Third>
                  You will be sent an email receipt each time your subscription
                  renews
                </Text.Third>
              </SubscriptionBlock.List.Item.Text>
            </SubscriptionBlock.List.Item>
          </SubscriptionBlock.List.Items>
        </PaymentBlock.Form>
        <PaymentBlock.Prebottom>
          <Text.Fifth style={{ color: "#6C6C6C", textAlign: "left" }}>
            Your 7-day trial last until 11:13 AM, December 10, 2021. You may
            cancel at any time before 11:13 AM, December 10,2021, and you will
            not be charged. If you don’t cancel, Journey will automatically
            continue your membership at the end of your 7-day trial and charge
            the membership fee (currently $69.99) on a yearly basis until your
            cancel. No refunds or credits for partial years. You can cancel your
            subscriptions anytime on your Subscription Management page.
          </Text.Fifth>
        </PaymentBlock.Prebottom>
        {footerRender()}
      </PaymentBlock>
    );
  };

  const paymentFormRender = (contentRenderFunction, currentProduct) => {
    return (
      <div style={{ paddingTop: 35 }}>
        <Elements stripe={stripePromise}>
          <PaymentForm
            isPaypalMethod={isPaypalMethod}
            setPaypalMethod={setPaypalMethod}
            isPaypalAvailable={isPaypalAvailable}
            setPaypalAvailable={setPaypalAvailable}
            userEmail={userEmail}
            userSum={userSum}
            pixelObject={pixelObject}
            paypalActions={{
              [PAYWALL_FIRST]: setPaypalPopupVisible,
              [PAYWALL_FOURTH]: setPaypalPopupVisible,
            }}
            setWhyPopupVisible={setWhyPopupVisible}
            contentRenderFunction={contentRenderFunction}
            currentProduct={currentProduct}
          />
        </Elements>
      </div>
    );
  };

  const handleGetMyPlanClick = (withoutScroll) => {
    const paymentTypeObject = {
      type: isPaypalMethod ? "paypal" : "card",
    };
    setPaywallPopupOpen(false);

    const eventObj = createEventObjectFunction(null, null, landingId);
    eventObj.type = "long";

    // Событие №8 paywall open
    paywallOpenEvent(analytics, eventObj);
    paywallOpenEventAmplitude(eventObj);

    // событие payment type
    paymentTypeEvent(analytics, paymentTypeObject);
    paymentTypeEventAmplitude(paymentTypeObject);

    setPaymentVisible(true);
    if (!withoutScroll) {
      handleScrollToElement();
    }
  };

  const handleScrollToElement = () => {
    const block = formBlock.current;

    if (paywallState !== PAYWALL_FIRST) {
      window.scrollTo(0, document.body);
    } else {
      window.scrollTo({
        top: block.getBoundingClientRect().top + window.scrollY - 50,
        behavior: "smooth",
      });
    }
  };

  // POPUPS ////////////////////////////////////////////////////////
  const renderPopupContent = () => {
    return (
      <div>
        <Heading.Second style={{ marginBottom: 16, color: blackColor }}>
          Enjoy instant results!
        </Heading.Second>
        {remoteConfig.paidTrialEnabled ? null : (
          <Text.Fourth style={{ color: purpleColor, marginBottom: 16 }}>
            We ask for your payment information now so you can enjoy Journey
            uninterrupted after your <b>7-day trial ends.</b>
          </Text.Fourth>
        )}
        {remoteConfig.paidTrialEnabled ? (
          <Text.Fourth style={{ color: purpleColor, marginBottom: 47 }}>
            If you cancel anytime before the end of the <b>7-day trial,</b> you
            won’t be charged the annual membership fee.
          </Text.Fourth>
        ) : (
          <Text.Fourth style={{ color: purpleColor, marginBottom: 47 }}>
            If you cancel anytime before the end of the <b>7-day trial,</b> you
            won’t be charged.
          </Text.Fourth>
        )}
        <Button
          type={"default"}
          isGradient={true}
          text={"Got it"}
          action={() => setWhyPopupVisible(false)}
        />
      </div>
    );
  };

  // paywall render functions block
  const renderPaywallPopup = () => {
    return (
      <PaywallPopupBlock>
        <div className="paywall-popup">
          <div className="paywall-popup-top">
            <img
              src={closeIcon}
              alt="close"
              onClick={() => setPaywallPopupOpen(false)}
            />
          </div>
          <div className="paywall-popup-content">
            <Text.Fourth
              style={{
                marginBottom: 10,
                color: purpleColor,
                textAlign: "center",
                fontWeight: 400,
              }}
            >
              Special welcome offer!
            </Text.Fourth>
            <Text
              style={{
                marginBottom: 48,
                color: blackColor,
                textAlign: "center",
                fontWeight: 700,
                fontSize: 25,
              }}
            >
              Get 30% off - Today only
            </Text>
            <div className="paywall-popup-text">
              <Text
                className="decor"
                style={{
                  marginBottom: 26,
                  color: "#E24B4B",
                  textAlign: "left",
                  fontWeight: 700,
                  fontSize: 25,
                  opacity: 0.7,
                }}
              >
                $99.99
              </Text>
              <Text
                style={{
                  marginBottom: 26,
                  color: blackColor,
                  fontWeight: 700,
                  fontSize: 25,
                }}
              >
                $69.99
              </Text>
            </div>
          </div>
          <div className="paywall-popup-button" style={{ marginBottom: 15 }}>
            <Button
              // className={"observer-element"}
              type={"default"}
              isGradient={true}
              text={"Get discount"}
              action={() => handleGetMyPlanClick()}
            />
          </div>
        </div>
      </PaywallPopupBlock>
    );
  };

  const renderPaypalPopup = () => {
    return (
      <PaypalPopupBlock>
        <div className="paypal-popup">
          <div className="paypal-popup-top">
            <img
              src={closeIcon}
              alt="close"
              onClick={() =>
                paypalPopupState === 0
                  ? setPaypalPopupVisible(false)
                  : handlePaypalClick()
              }
            />
          </div>
          <div
            className="paypal-popup-content"
            style={{ textAlign: paypalPopupState === 0 ? "center" : "left" }}
          >
            <img
              src={paypalPopupState === 0 ? paypalLetters : paypalBig}
              alt="letters"
            />
            <Heading.Fourth
              style={{
                marginBottom: 8,
                color: greyDarkColor,
                textAlign: paypalPopupState === 0 ? "center" : "left",
                fontWeight: 500,
              }}
            >
              {paypalPopupState === 0 ? "Pay with PayPal" : "We’re sorry"}
            </Heading.Fourth>
            <Heading.Fourth
              style={{
                marginBottom: 22,
                color: paypalPopupState === 0 ? greyDarkColor : greyLightColor,
                textAlign: paypalPopupState === 0 ? "center" : "left",
                fontWeight: 400,
                fontSize: 17,
                lineHeight: "22px",
              }}
            >
              {paypalPopupState === 0
                ? " Enter your email or mobile number to get started."
                : "Things don't appear to be working at the moment."}
            </Heading.Fourth>
            {paypalPopupState === 0 ? (
              <div style={{ position: "relative" }}>
                {isInputError ? (
                  <CardInputWrapper.Message.Paypal>
                    Required
                  </CardInputWrapper.Message.Paypal>
                ) : null}
                <CardInputWrapper.Paypal
                  isValid={!isInputError}
                  isComplete={isInputFill}
                  style={{ marginBottom: 40 }}
                  onClick={handleInputClick}
                >
                  <input
                    type="text"
                    placeholder={"Email or mobile number"}
                    onChange={(e) => handlePaypalInputChange(e.target.value)}
                  />
                  {isInputError ? (
                    <img
                      src={warningIcon}
                      style={{ position: "absolute", right: 14, top: 20 }}
                    />
                  ) : null}
                </CardInputWrapper.Paypal>
              </div>
            ) : null}
          </div>
          <div className="paypal-popup-button">
            <Button
              type={"default"}
              text={
                paypalPopupState === 0
                  ? "Next"
                  : "Return and pay with Сredit Сard"
              }
              action={() => handlePaypalClick()}
              style={{
                background: blueColor,
                height: 42,
              }}
              color={whiteColor}
              fontSize={17}
              fontWeight={400}
            />
          </div>
        </div>
      </PaypalPopupBlock>
    );
  };

  const handlePaypalInputChange = (value) => {
    if (value.length > 0) {
      setInputFill(true);
      setInputError(false);
    } else {
      setInputFill(false);
      setInputError(true);
    }
  };

  const handleInputClick = () => {
    if (paypalInputClicked === false) {
      const eventObj = createEventObjectFunction(null, null, landingId);

      // Событие №9 paymentinfo_add
      paymentInfoAddEvent(analytics, eventObj);
      paymentInfoAddEventAmplitude(eventObj);
      setPaypalInputClicked(true);
    } else {
      return false;
    }
  };

  const handlePaypalClick = () => {
    if (!isInputFill) {
      setInputError(true);
      return false;
    } else {
      if (paypalPopupState === 0) {
        setPaypalState(1);
      } else {
        setPaypalAvailable(false);
        setPaypalMethod(false);
        setPaypalPopupVisible(false);
      }
    }
  };

  // END POPUPS ////////////////////////////////////////////////////////

  // PAYWALLS RENDER //////////////////////////////////////////////////

  const firstPaywallTopRender = () => {
    return (
      <div className="paywall-first">
        <div className="paywall-first-logo">
          <img src={logoImg} alt="logo" style={{ marginBottom: 8 }} />
          <Heading.Third style={{ marginBottom: 18 }}>
            {remoteConfig.paidTrialEnabled
              ? "Start your 7-day trial with Journey Digital Sleep Coach"
              : "Start your Free trial with Journey Digital Sleep Coach"}
          </Heading.Third>
        </div>
        {paywallFirstTopRender()}
        {paywallGuaranteeRender()}
        <div className="paywall-first-center">
          <div className="paywall-first-total">
            <Text.Third
              style={{
                color: blackColor,
                fontWeight: 600,
              }}
            >
              Total today
            </Text.Third>
            {!remoteConfig.paidTrialEnabled ? (
              <Text.Third
                style={{
                  color: orangeColor,
                  fontWeight: 600,
                }}
              >
                0$
              </Text.Third>
            ) : null}
          </div>
          <div
            className="paywall-first-between"
            style={{ marginTop: 18, marginBottom: 18 }}
          >
            <Text.Third
              style={{
                color: blackColor,
                fontWeight: 400,
              }}
            >
              {!remoteConfig.paidTrialEnabled
                ? "Price after 7-day free trial"
                : `7-day trial`}
            </Text.Third>
            <Text.Third
              style={{
                color: blackColor,
                fontWeight: 700,
              }}
            >
              {!remoteConfig.paidTrialEnabled ? "$1.35/week" : `$${userSum}`}
            </Text.Third>
          </div>
          {!remoteConfig.paidTrialEnabled ? (
            <div className="paywall-first-between" style={{ marginBottom: 6 }}>
              <Text.Third
                style={{
                  color: blackColor,
                  fontWeight: 400,
                }}
              >
                Billed annually at
              </Text.Third>
              <div className="paywall-first-between-text">
                <Text
                  className="decor"
                  style={{
                    color: blueDarkColor,
                    textAlign: "left",
                    fontWeight: 600,
                    fontSize: 18,
                    opacity: 0.7,
                  }}
                >
                  $99.99
                </Text>
                <Text
                  style={{
                    color: blackColor,
                    fontWeight: 600,
                    fontSize: 18,
                  }}
                >
                  $69.99
                </Text>
              </div>
            </div>
          ) : (
            <>
              <div
                className="paywall-first-between-paid"
                style={{ marginBottom: 19 }}
              >
                <Heading.Fifth
                  style={{
                    color: blackColor,
                    fontWeight: 600,
                  }}
                >
                  Price after trial:
                </Heading.Fifth>
              </div>
              <div
                className="paywall-first-between-banner"
                style={{ marginBottom: 5 }}
              >
                <Text.Fifth style={{ color: whiteColor }}>30% OFF</Text.Fifth>
              </div>
              <div
                className="paywall-first-between"
                style={{ marginBottom: 6 }}
              >
                <Text.Third
                  style={{
                    color: blackColor,
                    fontWeight: 400,
                  }}
                >
                  Annual plan
                </Text.Third>
                <div className="paywall-first-between-text">
                  <Text
                    className="decor"
                    style={{
                      color: blueDarkColor,
                      textAlign: "left",
                      fontWeight: 600,
                      fontSize: 18,
                      opacity: 0.7,
                    }}
                  >
                    $99.99
                  </Text>
                  <Text
                    style={{
                      color: blackColor,
                      fontWeight: 600,
                      fontSize: 18,
                    }}
                  >
                    $69.99
                  </Text>
                </div>
              </div>
            </>
          )}
        </div>
        <div style={{ marginBottom: 40 }}>
          <Button
            // className={"observer-element"}
            type={"default"}
            isGradient={true}
            text={
              remoteConfig.paidTrialEnabled
                ? "Start Your 7-Day Trial"
                : "Start 7-Day Free Trial"
            }
            action={() => handleGetMyPlanClick()}
          />
          {!remoteConfig.paidTrialEnabled ? (
            <Text.Fourth
              style={{ color: blueDarkColor, opacity: 0.7, marginTop: 12 }}
            >
              You won't be charged until your trial is over.
            </Text.Fourth>
          ) : null}
        </div>
        {ratingBlockRender()}
        <div className="paywall-comments-new">{commentsNewRender()}</div>
        <div style={{ marginBottom: 35, marginTop: 20 }}>
          {/*<Button*/}
          {/*  // className={"observer-element"}*/}
          {/*  type={"default"}*/}
          {/*  isGradient={true}*/}
          {/*  text={*/}
          {/*    remoteConfig.paidTrialEnabled*/}
          {/*      ? "Start Your 7-Day Trial"*/}
          {/*      : "Start 7-Day Free Trial"*/}
          {/*  }*/}
          {/*  action={() => handleGetMyPlanClick()}*/}
          {/*/>*/}
          {/*{!remoteConfig.paidTrialEnabled ? (*/}
          {/*  <Text.Fourth*/}
          {/*    style={{ color: blueDarkColor, opacity: 0.7, marginTop: 12 }}*/}
          {/*  >*/}
          {/*    You won't be charged until your trial is over.*/}
          {/*  </Text.Fourth>*/}
          {/*) : null}*/}
        </div>
        <div
          ref={formBlock}
          style={{
            marginLeft: -20,
            marginRight: -20,
            background: whiteColor,
            paddingRight: 20,
            paddingLeft: 20,
            // paddingTop: 35,
          }}
        >
          {/*{isPaymentVisible ? paymentFormRender() : null}*/}
          {paymentFormRender()}
        </div>
      </div>
    );
  };

  const secondPaywallTopRender = () => {
    return (
      <div className="paywall-second-wrapper">
        <div className="paywall-second">
          <div className="paywall-second-text">
            <Text
              style={{
                marginBottom: 30,
                textAlign: "center",
                fontSize: 28,
                lineHeight: "39px",
                color: whiteColor,
              }}
            >
              <span>Get a Personalized Sleepscape plan </span>{" "}
              <span style={{ fontWeight: 700 }}>with 30% off </span>{" "}
              <span>of Journey Premium </span>{" "}
            </Text>
          </div>
          <div className="paywall-second-button" style={{ marginBottom: 53 }}>
            <Button
              type={"default"}
              text={"Get my sleepscape plan"}
              action={() => handleGetMyPlanClick()}
              style={{ background: lightSecondColor }}
            />
          </div>
          <div className="paywall-second-img">
            <img
              src={avatarsIcon}
              alt="avatar"
              style={{ width: 100, height: 38, objectFit: "cover" }}
            />
          </div>
          <Text.Fifth style={{ color: greyTextColor }}>
            Over 100,000 Happy Users
          </Text.Fifth>
        </div>
        <div className="paywall-second-slider">
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={20}
            autoplay={{ delay: 8000 }}
            // onSwiper={(swiper) => console.log(swiper)}
            onSlideChange={(swiper) => setActiveBullet(swiper.activeIndex)}
          >
            {comments.map((comment) => {
              return (
                <SwiperSlide>
                  <div className="slide">
                    <div className="slide-content">
                      <div className="slide-stars" style={{ marginBottom: 11 }}>
                        <img src={comment.img} alt="stars" />
                      </div>
                      <div className="slide-text" style={{ marginBottom: 24 }}>
                        <Text
                          style={{
                            fontSize: 22,
                            lineHeight: "28px",
                            color: blackColor,
                          }}
                        >
                          {comment.text}
                        </Text>
                      </div>
                      <div className="slide-name">
                        <Text.Fourth style={{ color: greyAddColor }}>
                          {comment.name}
                        </Text.Fourth>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
          <div className="paywall-second-slider-bullets">
            {comments.map((i, index) => {
              return (
                <div
                  className={`paywall-second-slider-bullet ${
                    index === activeBullet ? "active" : null
                  }`}
                  key={index}
                />
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  const thirdPaywallTopRender = () => {
    return (
      <div className="paywall-third">
        <div className="paywall-third-text">
          <Text
            style={{
              marginBottom: 7,
              textAlign: "left",
              fontSize: 28,
              lineHeight: "36px",
              color: blackColor,
              fontWeight: 700,
            }}
          >
            Fix sleep problems from the comfort of your home
          </Text>
          <Text.Third
            style={{
              marginBottom: 20,
              textAlign: "left",
              color: blackColor,
            }}
          >
            Journey can help you manage sleep problems and feel better with a
            science-backed personalized sleep program based on the latest CBT
            research.
          </Text.Third>
        </div>
        <div className="paywall-third-list">
          {secondItems.map((item, index) => {
            return (
              <div className="paywall-third-item" key={index}>
                <div
                  className="paywall-third-item-img"
                  style={{ marginRight: 16 }}
                >
                  <img src={item.icon} alt="icon" />
                </div>
                <div className="paywall-third-item-text">
                  <Text.Third style={{ paddingBottom: 7, color: purpleColor }}>
                    {item.text}
                  </Text.Third>
                </div>
              </div>
            );
          })}
        </div>
        <div className="paywall-third-button">
          <Button
            type={"default"}
            isGradient={true}
            text={"Get my sleepscape plan"}
            action={() => handleGetMyPlanClick()}
          />
        </div>
      </div>
    );
  };

  const fourthPaywallTopRender = () => {
    return (
      <div className="paywall-first">
        <div className="paywall-first-logo">
          <img src={logoImg} alt="logo" style={{ marginBottom: 8 }} />
          <Heading.Third style={{ marginBottom: 18 }}>
            Start your free trial with Journey Digital Sleep Coach
          </Heading.Third>
        </div>
        {paywallFirstTopRender()}
        <div className="paywall-first-center" style={{ border: "none" }}>
          <div className="paywall-first-total">
            <Text.Third
              style={{
                color: blackColor,
                fontWeight: 600,
              }}
            >
              Total today
            </Text.Third>
            <Text.Third
              style={{
                color: orangeColor,
                fontWeight: 600,
              }}
            >
              $0
            </Text.Third>
          </div>
        </div>
        {infoBlockRender()}
        <div style={{ marginBottom: 40 }}>
          <Button
            // className={"observer-element"}
            type={"default"}
            isGradient={true}
            text={
              remoteConfig.paidTrialEnabled
                ? "Start Your 7-Day Trial"
                : "Start 7-Day Free Trial"
            }
            action={() => handleGetMyPlanClick()}
          />
          {!remoteConfig.paidTrialEnabled ? (
            <Text.Fourth
              style={{ color: blueDarkColor, opacity: 0.7, marginTop: 12 }}
            >
              You won't be charged until your trial is over.
            </Text.Fourth>
          ) : null}
        </div>
        {paywallTimelineRender()}
        <div style={{ marginBottom: 20 }}>{paywallGuaranteeRender()}</div>
        <div style={{ marginBottom: 40 }}>{ratingBlockRender()}</div>
        <div className="paywall-comments-new">
          <Heading.Third
            style={{
              width: 224,
              color: blackColor,
              fontWeight: 800,
              margin: "0 auto 19px auto",
            }}
          >
            Success stories from our users
          </Heading.Third>
          {paywallSliderCommentRender()}
        </div>
        <div
          ref={formBlock}
          style={{
            marginLeft: -20,
            marginRight: -20,
            background: whiteColor,
            paddingRight: 20,
            paddingLeft: 20,
            // paddingTop: 35,
          }}
        >
          {paymentFormRender(infoBlockRender, process.env.REACT_APP_PRODUCT_19)}
        </div>
      </div>
    );
  };

  // ELEMENTS PAYWALL RENDER
  const paywallFirstTopRender = () => {
    return (
      <div className="paywall-first-top">
        <div className="paywall-first-content">
          <Text.Third
            style={{
              marginBottom: 10,
              color: blackColor,
              textAlign: "left",
              fontWeight: 600,
            }}
          >
            What you'll get:
          </Text.Third>
          <ul>
            <li>Personalized sleep plan</li>
            <li>Tailor-made sleep course</li>
            <li>Full access to the unique content</li>
            <li>Sleep coach support</li>
            <li>500+ сalming sleep stories, nature sounds and meditations</li>
          </ul>
          <Text.Third
            style={{
              marginBottom: 15,
              color: blackColor,
              textAlign: "left",
              fontWeight: 600,
            }}
          >
            Rely on expert advice:
          </Text.Third>
        </div>
        <div className="paywall-first-dr">
          <div className="paywall-first-dr-left">
            <img
              src={drNewIcon}
              alt="dr"
              style={{ width: 62, height: 62, objectFit: "contain" }}
            />
          </div>
          <div className="paywall-first-dr-right">
            <Text.Fourth
              style={{
                marginBottom: 1,
                color: blackColor,
                textAlign: "left",
                fontWeight: 700,
              }}
            >
              Dr. John Cline, Ph.D.
            </Text.Fourth>
            <Text.Fifth
              style={{
                marginBottom: 8,
                color: purpleColor,
                textAlign: "left",
                fontWeight: 400,
              }}
            >
              Board-Certified Sleep Specialist
            </Text.Fifth>
            <img
              src={yaleIcon}
              alt="dr"
              style={{ width: 84, height: 12, objectFit: "cover" }}
            />
          </div>
        </div>
        <div className="paywall-first-dr">
          <div className="paywall-first-dr-left">
            <img
              src={drNew2Icon}
              alt="dr"
              style={{ width: 62, height: 62, objectFit: "contain" }}
            />
          </div>
          <div className="paywall-first-dr-right">
            <Text.Fourth
              style={{
                marginBottom: 1,
                color: blackColor,
                textAlign: "left",
                fontWeight: 700,
              }}
            >
              Dr. Amer Khan, M.D.
            </Text.Fourth>
            <Text.Fifth
              style={{
                marginBottom: 8,
                color: purpleColor,
                textAlign: "left",
                fontWeight: 400,
              }}
            >
              Board-Certified Neurologist
            </Text.Fifth>
            <img style={{ width: 75 }} src={healthIcon} alt="dr" />
          </div>
        </div>
      </div>
    );
  };

  const paywallGuaranteeRender = () => {
    return (
      <SubscriptionBlock.Guarantee
        paywall={paywallState}
        style={{ background: slideBgColor, paddingBottom: 50 }}
      >
        <Heading.Fifth
          style={{ marginBottom: 15, color: whiteColor, textAlign: "left" }}
        >
          100% Money-Back Guarantee
        </Heading.Fifth>
        <Text.Fourth
          style={{ marginBottom: 15, color: whiteColor, textAlign: "left" }}
        >
          {`You can claim a full refund within 30 days after your purchase if
              you have spent ${
                remoteConfig.paidTrialEnabled ? "7" : "10"
              } consecutive days completing at least 1 sleep coach
              recommendation and still feel Journey isn't right for you.`}
        </Text.Fourth>
        <img
          src={stampNew}
          alt="stamp"
          style={{ width: 74, height: 74, bottom: 15 }}
        />
      </SubscriptionBlock.Guarantee>
    );
  };

  const infoBlockRender = (mt, mb, bgColor) => {
    return (
      <Container.Items
        style={{
          marginBottom: mb || 23,
          backgroundColor: bgColor || "#ffffff",
          marginTop: mt || 0,
          paddingRight: 3,
        }}
      >
        <Heading.Fifth style={{ marginBottom: 12, textAlign: "left" }}>
          <span style={{ fontWeight: 600, color: blackColor }}>
            1 year $19.99
          </span>{" "}
          <span style={{ fontWeight: 400, fontSize: 16, color: blackColor }}>
            (after 7-day trial)
          </span>
        </Heading.Fifth>
        {paywallFourthlData.map((item) => {
          return (
            <ImageItem
              key={`${item.id}-prepaywall-data`}
              style={{
                marginBottom: item.id === paywallFourthlData.length - 1 ? 0 : 3,
              }}
            >
              <ImageItem.Img
                style={{
                  width: 15,
                  height: 22,
                  minWidth: 15,
                  marginRight: 7,
                  boxShadow: "none",
                  background: "inherit",
                }}
              >
                <img src={bird} alt="bird" />
              </ImageItem.Img>
              <ImageItem.Text style={{ minHeight: "auto" }}>
                <Text.Fourth
                  style={{
                    color: "rgba(5, 2, 55, 0.7)",
                    textAlign: "left",
                  }}
                >
                  <span>{item.text}</span>
                  {item.icon ? (
                    <span style={{ marginLeft: 5 }}>
                      <img src={item.icon} alt={item.text} />
                    </span>
                  ) : null}
                </Text.Fourth>
              </ImageItem.Text>
            </ImageItem>
          );
        })}
        <div className="paywall-info-sale">
          <Heading.Fifth style={{ color: whiteColor, fontWeight: 400 }}>
            Save 80%
          </Heading.Fifth>
        </div>
      </Container.Items>
    );
  };

  const paywallTimelineRender = () => {
    return (
      <div style={{ marginBottom: 38 }}>
        <Heading.Second
          style={{ color: blackColor, marginBottom: 24, fontWeight: 800 }}
        >
          How your free trial works
        </Heading.Second>
        <div className="paywall-timeline">
          <div
            className="paywall-timeline-left"
            style={{ height: 324, marginRight: 10 }}
          >
            <img style={{ maxWidth: "100%" }} src={timeLineImg} alt="" />
          </div>
          <div className="paywall-timeline-right">
            {fourth_paywall_timeline_items.map((item) => {
              return (
                <div
                  key={`${item.id}-timeline-item`}
                  style={{ maxWidth: 280, marginBottom: 32, marginTop: 15 }}
                >
                  <Text.Third
                    style={{
                      textAlign: "left",
                      color: blackColor,
                      marginBottom: 6,
                      fontWeight: 600,
                    }}
                  >
                    {item.title}
                  </Text.Third>
                  <Text.Fourth
                    style={{
                      textAlign: "left",
                      color: blueDarkColor,
                      opacity: 0.7,
                    }}
                    dangerouslySetInnerHTML={item.text}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  const paywallSliderCommentRender = () => {
    return (
      <PrepaywallBlock.Slider>
        <Swiper
          modules={[Pagination, Autoplay]}
          onSlideChange={(swiper) => setActiveBullet(swiper.activeIndex)}
          spaceBetween={25}
        >
          {commentsNew.map((comment) => {
            return (
              <SwiperSlide key={`${comment.id}-comment-slide`}>
                <div className="paywall-comment-new">
                  <div className="paywall-comment-new-text">
                    <Text.Fourth
                      style={{ textAlign: "left" }}
                      dangerouslySetInnerHTML={comment.text}
                    />
                  </div>
                  <div className="paywall-comment-new-bottom">
                    <div className="paywall-comment-new-avatar">
                      <div className="paywall-comment-new-image">
                        <img src={comment.avatar} alt="avatar" />
                      </div>
                      <div className="paywall-comment-new-name">
                        <Text.Fifth
                          style={{
                            fontWeight: 400,
                            color: purpleSecondColor,
                            textAlign: "left",
                          }}
                        >
                          {`${comment.name}, ${comment.age}`}
                        </Text.Fifth>
                        <Text.Fifth
                          style={{
                            fontWeight: 400,
                            color: purpleSecondColor,
                            textAlign: "left",
                          }}
                        >
                          {comment.place}
                        </Text.Fifth>
                      </div>
                    </div>
                    <div className="paywall-comment-new-stars">
                      <img src={comment.img} alt="stars" />
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
        <div className="paywall-bullets">
          {commentsNew.map((i, index) => {
            return (
              <div
                className={`paywall-bullet ${
                  index === activeBullet ? "active" : null
                }`}
                key={index}
              />
            );
          })}
        </div>
      </PrepaywallBlock.Slider>
    );
  };
  // END OF ELEMENTS PAYWALL RENDER

  const topBlockRender = () => {
    switch (currentPaywall) {
      case PAYWALL_FIRST:
        return firstPaywallTopRender();
      case PAYWALL_SECOND:
        return secondPaywallTopRender();
      case PAYWALL_THIRD:
        return thirdPaywallTopRender();
      case PAYWALL_FOURTH:
        return fourthPaywallTopRender();
    }
  };

  const newFooterRender = () => {
    return (
      <>
        <SubscriptionBlock.Bottom.New>
          <Container.Content>
            <Text.Fourth
              style={{ fontWeight: 800, marginBottom: 2, textAlign: "left" }}
            >
              Your information is safe
            </Text.Fourth>
            <Text.Fourth style={{ marginBottom: 24, textAlign: "left" }}>
              We will not sell or rent your personal contact information for any
              marketing purposes whatsoever.
            </Text.Fourth>
            <Text.Fourth
              style={{ fontWeight: 800, marginBottom: 2, textAlign: "left" }}
            >
              Secure checkout
            </Text.Fourth>
            <Text.Fourth style={{ marginBottom: 24, textAlign: "left" }}>
              All information is encrypted and transmitted without risk using a
              SSL protocol.
            </Text.Fourth>
            <Text.Fourth
              style={{ fontWeight: 800, marginBottom: 2, textAlign: "left" }}
            >
              Need any help?
            </Text.Fourth>
            <Text.Fourth style={{ marginBottom: 24, textAlign: "left" }}>
              <span>Contact us </span>{" "}
              <a
                href="mailto:support@gojourney.app"
                style={{ color: orangeColor, textDecoration: "none" }}
              >
                here
              </a>
            </Text.Fourth>
          </Container.Content>
        </SubscriptionBlock.Bottom.New>
        <SubscriptionBlock.Footer.New>
          <SubscriptionBlock.Footer.Top>
            <SubscriptionBlock.Footer.Top.Item>
              <a style={{ textDecoration: "none" }} href={TERMS_LINK}>
                <Text.Third style={{ color: blackColor }}>
                  Terms of Use
                </Text.Third>
              </a>
            </SubscriptionBlock.Footer.Top.Item>
            <SubscriptionBlock.Footer.Top.Item>
              <a style={{ textDecoration: "none" }} href={PRIVACY_LINK}>
                <Text.Third style={{ color: blackColor }}>
                  Privacy Policy
                </Text.Third>
              </a>
            </SubscriptionBlock.Footer.Top.Item>
          </SubscriptionBlock.Footer.Top>
          <SubscriptionBlock.Footer.Bottom>
            <Text.Fifth style={{ color: disabledColor }}>
              {`© ${getCurrentYear()} Journey Inc.`}
            </Text.Fifth>
            <Text.Fifth style={{ color: disabledColor }}>
              {` All Rights Reserved.`}
            </Text.Fifth>
          </SubscriptionBlock.Footer.Bottom>
        </SubscriptionBlock.Footer.New>
      </>
    );
  };

  const footerRender = () => {
    return (
      <>
        <SubscriptionBlock.Bottom>
          <Text.Fourth
            style={{ fontWeight: 800, marginBottom: 2, textAlign: "left" }}
          >
            Your information is safe
          </Text.Fourth>
          <Text.Fourth style={{ marginBottom: 24, textAlign: "left" }}>
            We will not sell or rent your personal contact information for any
            marketing purposes whatsoever.
          </Text.Fourth>
          <Text.Fourth
            style={{ fontWeight: 800, marginBottom: 2, textAlign: "left" }}
          >
            Secure checkout
          </Text.Fourth>
          <Text.Fourth style={{ marginBottom: 24, textAlign: "left" }}>
            All information is encrypted and transmitted without risk using a
            Secure Sockets Layer protocol.
          </Text.Fourth>
          <Text.Fourth
            style={{ fontWeight: 800, marginBottom: 2, textAlign: "left" }}
          >
            Need any help?
          </Text.Fourth>
          <Text.Fourth style={{ marginBottom: 24, textAlign: "left" }}>
            <span>Contact us </span>{" "}
            <a
              href="mailto:support@gojourney.app"
              style={{ color: orangeColor, textDecoration: "none" }}
            >
              here
            </a>
          </Text.Fourth>
        </SubscriptionBlock.Bottom>
        <SubscriptionBlock.Footer>
          <SubscriptionBlock.Footer.Top>
            <SubscriptionBlock.Footer.Top.Item>
              <a style={{ textDecoration: "none" }} href={TERMS_LINK}>
                <Text.Third style={{ color: "#8B8991" }}>
                  Terms of Use
                </Text.Third>
              </a>
            </SubscriptionBlock.Footer.Top.Item>
            <SubscriptionBlock.Footer.Top.Item>
              <a style={{ textDecoration: "none" }} href={PRIVACY_LINK}>
                <Text.Third style={{ color: "#8B8991" }}>
                  Privacy Policy
                </Text.Third>
              </a>
            </SubscriptionBlock.Footer.Top.Item>
          </SubscriptionBlock.Footer.Top>
          <SubscriptionBlock.Footer.Bottom>
            <Text.Fifth style={{ color: "#B0AFB3" }}>
              © 2021 Journey Inc.<br></br> All Rights Reserved.
            </Text.Fifth>
          </SubscriptionBlock.Footer.Bottom>
        </SubscriptionBlock.Footer>
      </>
    );
  };

  const ratingDataArray = [
    {
      count: "8K",
      text: "5-stars ratings",
    },
    {
      count: "200K+",
      text: "downloads",
    },
  ];

  const ratingBlockRender = () => {
    return (
      <div className="paywall-first-rating">
        <div className="paywall-first-rating-top">
          <div className="paywall-first-rating-top-left">
            <img src={appleIcon} alt="apple" style={{ width: 55 }} />
          </div>
          <div className="paywall-first-rating-top-right">
            <div className="paywall-first-rating-count">
              <div className="paywall-first-rating-count-left">
                <img src={ratingIcon} alt="rating" style={{ marginRight: 7 }} />
              </div>
              <div className="paywall-first-rating-count-out">out of 5</div>
            </div>
            <div className="paywall-first-rating-count-icon">
              <img src={starsIcon} alt="stars" />
            </div>
          </div>
        </div>
        <div className="paywall-first-rating-bottom">
          {ratingDataArray.map((ratingObject, index) => {
            return (
              <div
                className="paywall-first-rating-bottom-item"
                key={`${index}-rating`}
              >
                <div className="paywall-first-rating-bottom-item-top">
                  <Text.Fourth style={{ fontWeight: 800, color: blackColor }}>
                    {ratingObject.count}
                  </Text.Fourth>
                </div>
                <div className="paywall-first-rating-bottom-item-bottom">
                  <Text.Fourth style={{ opacity: 0.7, color: blackColor }}>
                    {ratingObject.text}
                  </Text.Fourth>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const paywallContentRender = () => {
    return (
      <div>
        <TimeBlock className={false ? "visible" : null}>
          <Text.Third>
            <span
              style={{
                fontWeight: 700,
              }}
            >
              7-day trial offer expires in{" "}
            </span>
            <span
              style={{
                color: orangeColor,
                fontWeight: 700,
              }}
            >
              {counter === 0 ? "0:00" : format(counter)}
            </span>
          </Text.Third>
        </TimeBlock>
        <Container.Content>
          <SubscriptionBlock.Top>
            <PaywallTopBlock>{topBlockRender()}</PaywallTopBlock>
          </SubscriptionBlock.Top>
          {paywallState !== PAYWALL_FIRST ? (
            <>
              <SubscriptionBlock.Chart>
                <Heading.Third
                  style={{
                    marginBottom: 7,
                    color: blackColor,
                    fontWeight: 800,
                    fontSize: 24,
                  }}
                >
                  Unlock everything with Journey Premium
                </Heading.Third>
                <Text.Fourth style={{ marginBottom: 46, color: blackColor }}>
                  Personal Sleep Coach will help you on your way to the perfect
                  sleep
                </Text.Fourth>
                <SubscriptionBlock.Chart.Img>
                  <img src={tableIcon} alt="" />
                </SubscriptionBlock.Chart.Img>
              </SubscriptionBlock.Chart>
              <SubscriptionBlock.Cost>
                <div>
                  <Button
                    className={"observer-element"}
                    type={"default"}
                    isGradient={true}
                    text={
                      remoteConfig.paidTrialEnabled
                        ? "Start Your 7-Day Trial"
                        : "Start 7-Day Free Trial"
                    }
                    action={() => handleGetMyPlanClick()}
                  />
                </div>
              </SubscriptionBlock.Cost>
              <SubscriptionBlock.Guarantee paywall={paywallState}>
                <Heading.Third style={{ marginBottom: 15 }}>
                  100% Money-Back Guarantee
                </Heading.Third>
                <Text.Fourth
                  style={{
                    marginBottom: 15,
                    color: blackColor,
                    textAlign: "left",
                  }}
                >
                  We are confident with our service quality and its results. So,
                  if you are ready to reach your goals, it’s a risk-free offer.
                  We guarantee you’ll see visible results or you’ll receive a
                  full refund within 30 days after your purchase.
                </Text.Fourth>
                <Text.Fourth
                  style={{
                    marginBottom: 10,
                    color: blackColor,
                    textAlign: "left",
                  }}
                >
                  Eligibility requirements:
                </Text.Fourth>
                <ul>
                  <li>
                    Submit request within<br></br> 30 days after your purchase
                  </li>
                  <li>
                    Spend 10 consecutive days<br></br> completing at least 1
                    sleepscape
                  </li>
                </ul>
                <img src={stamp} alt="stamp" />
              </SubscriptionBlock.Guarantee>
            </>
          ) : null}
          {paywallState !== PAYWALL_SECOND && paywallState !== PAYWALL_FIRST ? (
            <SubscriptionBlock.Comments>
              <Heading.Third style={{ textAlign: "left", marginBottom: 27 }}>
                People say about Journey
              </Heading.Third>
              {commentsRender()}
            </SubscriptionBlock.Comments>
          ) : null}
          {paywallState !== PAYWALL_FIRST ? footerRender() : null}
        </Container.Content>
        {/*<SubscriptionBlock.Fixed*/}
        {/*  className={!isVisible && !isVisibleForm && "button-visible"}*/}
        {/*>*/}
        {/*  <Button*/}
        {/*    type={"default"}*/}
        {/*    isGradient={true}*/}
        {/*    text={"Start 7-Day Free Trial"}*/}
        {/*    action={() => handleGetMyPlanClick()}*/}
        {/*  />*/}
        {/*</SubscriptionBlock.Fixed>*/}
        {paywallState === PAYWALL_FIRST ? newFooterRender() : null}
      </div>
    );
  };

  return (
    <SubscriptionBlock paywallState={paywallState}>
      {paywallState === PAYWALL_FIRST ? (
        <>
          <img className="blue" src={blueBg} alt="bg" />
          <img className="purple" src={purpleBg} alt="bg" style={{ top: 60 }} />
        </>
      ) : null}
      {isPaymentVisible && paywallState !== PAYWALL_FIRST ? (
        <Container.Content>
          <SubscriptionBlock.Form>
            <div>{paymentBlockRender()}</div>
          </SubscriptionBlock.Form>
        </Container.Content>
      ) : (
        paywallContentRender()
      )}
      {isWhyPopupVisible && (
        <PopupTemplate contentFunction={renderPopupContent} />
      )}
      {isPaywallPopupOpen && paywallState !== PAYWALL_FIRST && (
        <PopupTemplate contentFunction={renderPaywallPopup} />
      )}
      {isPaypalPopupVisible && paywallState === PAYWALL_FIRST && (
        <PopupTemplate contentFunction={renderPaypalPopup} />
      )}
    </SubscriptionBlock>
  );
};

export default Paywall;
